import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import { compose, withHandlers } from 'recompose';

import BarberSelect from '../components/BarberSelect';
import { getDeletedBarbers } from '../../../barbers/actions';
import { getShop, getTimezone } from '../../../../auth/selectors';
import {
  getAll as getAllBarbers,
  getAllDeleted as getAllDeletedBarbers,
} from '../../../barbers/selector';

export default compose(
  connect(
    state => ({
      shopId: getShop(state),
      barbers: [...getAllBarbers(state), ...getAllDeletedBarbers(state)],
      timezone: getTimezone(state),
    }),
    { getDeletedBarbers },
  ),
  withHandlers({
    onChange: props => (e) => {
      props.onChange(e.target.value);
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.getDeletedBarbers(this.props.shopId);
    },
  }),
)(BarberSelect);
